import { render, staticRenderFns } from "./evidenceHistory.vue?vue&type=template&id=605912f7&scoped=true&"
import script from "./evidenceHistory.vue?vue&type=script&lang=js&"
export * from "./evidenceHistory.vue?vue&type=script&lang=js&"
import style0 from "./evidenceHistory.vue?vue&type=style&index=0&id=605912f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605912f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605912f7')) {
      api.createRecord('605912f7', component.options)
    } else {
      api.reload('605912f7', component.options)
    }
    module.hot.accept("./evidenceHistory.vue?vue&type=template&id=605912f7&scoped=true&", function () {
      api.rerender('605912f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/evidenceHistory.vue"
export default component.exports